import '@/api/pdf'

import api from '@/api/base'

export default api
